export const buildDataSetObject = (dataSet) => _.mapKeys(dataSet || [], (value, key) => 'data-' + key)



// WEBPACK FOOTER //
// ./src/common/components/js/componentsUtils.js